export default function px2rem () {
  let rootHtml, deviceWidth
    rootHtml = document.documentElement
    deviceWidth = rootHtml.clientWidth
    rootHtml.style.fontSize = deviceWidth / (750 / 100) + 'px'
}
